import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { stopDroneHub } from "../hooks/DroneHubConnection";
import { logger } from "../utils/logger";

export const useLogout = (): (() => Promise<void>) => {
    const navigate = useNavigate();
    const { logout: closeSession } = useAuth();

    const logout = async (): Promise<void> => {
        try {
            // Тела у запроса нет: сессию сервер находит по cookie hawk.sid.
            await closeSession();
        } catch (error) {
            logger.error("Logout error:", error);
        } finally {
            // Соединение с хабом общее на всё приложение и переживает уход с
            // консоли. После выхода сессии нет, и без явного stop оно бы вечно
            // переподключалось от имени несуществующего пользователя.
            stopDroneHub();
            navigate("/login", { replace: true });
        }
    };

    return logout;
};
